module.exports = __webpack_public_path__ + "img/CY.ce826661.svg";